import { render } from "./CadastrarLocalizacao.vue?vue&type=template&id=2287d8aa&scoped=true"
import script from "./CadastrarLocalizacao.vue?vue&type=script&lang=js"
export * from "./CadastrarLocalizacao.vue?vue&type=script&lang=js"

import "./CadastrarLocalizacao.vue?vue&type=style&index=0&id=2287d8aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2287d8aa"]])

export default __exports__